import ClientsAxios from "../client-axios";
import { DocumentBlobRequest } from "../dto/request";
import { ResponseEntity } from "../dto/response";
import { ProformaInvoiceBalanceDetailsResponse } from "../dto/response/quotation/quotation";

const { API_SERVER } = ClientsAxios;

export const StoreProformaInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('proforma-invoice/store', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateProformaInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('proforma-invoice/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchProformaInvoiceDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('proforma-invoice/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const FetchProformaInvoiceListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('proforma-invoice/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


export const DeleteProformaInvoiceService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('proforma-invoice/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}
export const StoreProductDocumentsService = async (payload: any) => {
    try {
        const response = await API_SERVER.post('proforma-invoice/store/doument', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        return response
    } catch (error: any) {
        const response = error.response || {};
        return response
    }
}

export const FetchDocumnetBlobService = async (payload: DocumentBlobRequest, options: { signal?: AbortSignal } = {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {        
        const response = await API_SERVER.post('document/pdf', payload, {
            responseType: 'blob',
            signal: options.signal, 
        });
        responseEntity.success(response, 200, "Success");
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data || {});
    }
    return responseEntity;
};



export const ChangePIStatusService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('proforma-invoice/status-update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchDocumentService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('/document/view', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}

export const FetchFileService = async (payload: any, options: { signal?: AbortSignal } = {}): Promise<any> => {
    try {
        const response = await API_SERVER.post(`/document/view`, payload,
            { 
                responseType: 'blob',
                signal: options.signal,
             });
        return response;

    } catch (error: any) {
        if (options.signal?.aborted) {
            console.error('Request aborted');
        } else {
            console.error('Error fetching file with hash:', error.message);
        }
        throw error;
    }
};

const exportKeyUrls: Record<string, string> = {
    proforma_invoice: 'proforma-invoice',
    invoice: 'invoice',
    payment_ledger: 'payment-ledger',
    irm: 'irm',
};

export const ExportExcelBlobService = async (payload: any, type: "invoice" | "proforma_invoice" | "irm" , options: { signal?: AbortSignal } = {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {        
        const urlKey = exportKeyUrls[type];
        const response = await API_SERVER.post(`${urlKey}/excel-export`, payload, {
            responseType: 'blob',
            signal: options.signal, 
        });
        responseEntity.success(response, 200, "Success");
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data || {});
    }
    return responseEntity;
};


export const FetchPIBalanceDetailsService = async (payload: { pi_id: number }) => {
    const responseEntity = new ResponseEntity<ProformaInvoiceBalanceDetailsResponse>();
    try {
        const response = await API_SERVER.post('proforma-invoice/remaining-balance', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}